import { createContext } from 'react';
export default createContext({
  label: '',
  nodeData: {
    code: ''
  }
});